import type { MatDialog } from '@angular/material/dialog';
import { CardError, CardErrorSeverity } from '../models/card-model';
import {
	JeptoErrorDetailsModalComponent,
	type ErrorDetailsModalData,
} from '../components/cards/jepto-error-details-modal/jepto-error-details-modal.component';

/** CSS class for card error chrome from severity. */
export function cardErrorSeverityCssClass(
	severity: CardErrorSeverity | undefined
): string {
	switch (severity) {
		case CardErrorSeverity.Info:
			return 'error-info';
		case CardErrorSeverity.Warning:
			return 'error-warning';
		case CardErrorSeverity.Critical:
			return 'error-critical';
		case CardErrorSeverity.Error:
		default:
			return 'error-error';
	}
}

/** Material icon name for card error chrome from severity. */
export function cardErrorSeverityIcon(
	severity: CardErrorSeverity | undefined
): string {
	switch (severity) {
		case CardErrorSeverity.Info:
			return 'info';
		case CardErrorSeverity.Warning:
			return 'warning';
		case CardErrorSeverity.Critical:
			return 'error';
		case CardErrorSeverity.Error:
		default:
			return 'error_outline';
	}
}

/** First defined card error in priority order (input → extras → config → data). */
export function resolvePriorityCardError(
	...sources: Array<CardError | null | undefined>
): CardError | null {
	for (const err of sources) {
		if (err) {
			return err;
		}
	}
	return null;
}

/** Open the shared error-details modal for a card. */
export function openCardErrorDetailsDialog(
	dialog: MatDialog,
	err: CardError,
	options?: { cardId?: string; cardTitle?: string }
): void {
	const modalData: ErrorDetailsModalData = {
		error: err,
		cardId: options?.cardId,
		cardTitle: options?.cardTitle,
	};

	dialog.open(JeptoErrorDetailsModalComponent, {
		data: modalData,
		panelClass: 'error-details-modal-panel',
		maxWidth: '90vw',
		maxHeight: '90vh',
	});
}
